var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframeUrl !== null)?_c('iframe',{staticClass:"w-full h-screen",attrs:{"src":_vm.iframeUrl,"frameborder":"0","allowtransparency":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }